export const SearchHeaderPlugin = () => {
    return '';
};

